import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'services/baseQueryWithAuth';

export type GroupBy = 'transaction' | null;

export interface GetPayoutReportSignedUrlArgs {
  recipient_id: string;
  report_id: string;
}

export const getPayoutReportSignedUrlApi = createApi({
  reducerPath: 'getPayoutReportSignedUrlApi',
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getPayoutReportSignedUrl: builder.mutation<string, GetPayoutReportSignedUrlArgs>({
      query: ({ recipient_id, report_id }) => ({
        url: `/admin/recipients/${recipient_id}/stripe-payout-reports/signed-url/${report_id}`,
        method: 'GET',
      }),
      transformResponse: (response: { signed_url?: string }) => response.signed_url || '',
    }),
  }),
});

export const { useGetPayoutReportSignedUrlMutation } = getPayoutReportSignedUrlApi;
